module.exports = __webpack_public_path__ + "static/media/18ECA3.5dff11a9.jpg";